// Prefer explicit override, otherwise:
// - if running the React dev server (port 3000), target the local backend on 8000
// - else use same-origin `/api` (production behind the nginx reverse proxy)
const envBase = process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL.replace(/\/$/, "")
  : undefined;

// Ensure the base points to the API prefix.
const API_BASE = envBase
  ? envBase.endsWith("/api")
    ? envBase
    : `${envBase}/api`
  : typeof window !== "undefined" && window.location.port === "3000"
    ? "http://localhost:8000/api"
    : `${window.location.origin}/api`;

export default API_BASE;
